<vdr-card title="Event list (이벤트 목록)" style="margin-top: 1rem">
  <div class="form-grid">
    <vdr-form-field
      label="Hide ended events from the list after (days)"
      tooltip="Counted from the event's end date. 0 keeps every event listed. Applies to everyone, including SuperAdmin — an event page can still be opened directly by its URL."
    >
      <input
        type="number"
        min="0"
        step="1"
        [(ngModel)]="hideEndedEventsAfterDays"
      />
    </vdr-form-field>
  </div>

  <button
    class="btn btn-primary"
    style="margin-top: 0.5rem"
    (click)="save()"
    [disabled]="saving"
  >
    {{ "common.update" | translate }}
  </button>
</vdr-card>
